<template>
  <div class="msg-detail">
    <navigation sticky>消息详情</navigation>
    <!-- 权益退款鉴权 -->
    <section class="content" >
      <div class="title">第三方平台信息确认</div>
      <p class="time">{{ detail.createTime | formateDate('YYYY/MM/DD HH:mm') }}</p>
      <div class="text">
        <p>平台已收到您的请求，正在请求第三方平台进行处理。<br>
          第三方平台将在核实您的信息后，进行处理。您的信息核实后，一般在30个工作日处理完成，请耐心等待…</p>
      </div>
    </section>
    <div class="footer" v-if="detail.verificationMode!=='NON'">
      <nd-button @click="visible=true">查询三方平台处理进度</nd-button>
    </div>

    <nd-dialog
      v-model="visible"
      close-btn
    >
      <div class="dialog-content" slot="custom">
        <div class="title">您正在前往第三方页面</div>
        <div class="dialog-detail">
          <h2>警惕“代退款”“退费代理”骗局</h2>
          <p>
            请您保护个人信息，勿向陌生人提供身份证、银行卡及短信验证码。<br>
            正规退款流程无需额外转账，任何要求“保证金”“服务费”的都是诈骗！谨防上当！
          </p>
        </div>
        <div class="btn-group">
          <nd-button class="btn" @click="$router.push(`/message/refund-auth?verificationMode=${detail.verificationMode}&recordNo=${detail.recordNo}`)">知悉并确认前往</nd-button>
        </div>
        <p class="info">相关服务由第三方平台提供</p>
      </div>
    </nd-dialog>
  </div>
</template>

<script>


import { mapActions } from 'vuex'
export default {
  
  data () {
    return {
      detail: {
        createTime: new Date()
      },
      content: '',
      visible: false
    }
  },
 
  async mounted () {
    this.getDetail()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('message', ['messageDetail', 'messageRead']),
    read () {
      this.messageRead({
        recordNo: this.$route.query.recordNo
      })
    },
    async getDetail () {
      const { success, data } = await this.messageDetail({
        recordNo: this.$route.query.recordNo
      })
      if (success && data) {
        this.detail = data
        this.content = data.content?.text
        if (this.detail.read === 'N') {
          this.read()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.msg-detail {
  height: 100vh;
  
  .dialog-content {
    background-color: #fff;
    width: 620px;
    border-radius: 30px;
    padding: 50px 40px 75px;
    font-family: PingFangSC, PingFang SC;
    .dialog-detail {
      background: #FFF6ED;
      border-radius: 12px;
      padding:24px 20px;
      font-size: 26px;
      color: #995939;
      line-height: 37px;
      margin-top: 24px;
      h2 {
        font-size: 32px;
        padding-bottom: 12px;
        text-align: center;
      }
    }
    .btn {
      width: 400px;
      height: 80px;
      line-height: 80px;
      margin:  40px auto 24px;
    }
    .title{
      font-size: 42px;
      color: #333333;
      text-align: center;
      line-height: 72px;
      font-weight: bold;
    }
    .info{
      font-size: 24px;
      color: #999;
      text-align: center;
      line-height: 45px;
    }
  }
  .content {
    padding: 20px;
    padding-bottom: 250px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    border-top: 20px solid #fafafa;
    font-size: 28px;

   .title {
      text-align: left;
      font-size: 36px;
      font-weight: bold;
    }
    .time {
      font-size: 24px;
      color: #999;
      margin-top: 10px;
    }
    .text {
      &.tr {text-align: right;}
      color:#666;
      margin-top: 15px;
    }
    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
.footer {
  display: flex;
  bottom: 0;
  height: 180px;
  background: #ffffff;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
}
</style>